<button
  class="chat-button"
  (click)="openChatDialog()"
  *ngIf="!disableButton"
  aria-label="Open Chat Assistant">
  <mat-icon>smart_toy</mat-icon>
</button>
